import { render, staticRenderFns } from "./ClaimFlow.vue?vue&type=template&id=4ba5a8ed&scoped=true&"
import script from "./ClaimFlow.vue?vue&type=script&lang=ts&"
export * from "./ClaimFlow.vue?vue&type=script&lang=ts&"
import style0 from "./ClaimFlow.vue?vue&type=style&index=0&id=4ba5a8ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba5a8ed",
  null
  
)

export default component.exports